import { Component, EventEmitter, Input, OnInit, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import { ToastService } from 'taxtank-core';

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FileComponent implements OnInit {
  protected toastService = inject(ToastService);

  @Input() control: AbstractControl;
  @Output() updated: EventEmitter<File> = new EventEmitter<File>();

  

  ngOnInit(): void {
    this.control.valueChanges.subscribe((file: File) => {
      if (!this.control.errors) {
        this.updated.emit(file);
        return;
      }

      Object.keys(this.control.errors).forEach((key: string) => {
        this.toastService.error(this.control.errors[key]);
      });
    });
  }
}
